export default "__VITE_ASSET__DWvd3a_$__"